import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AppComponent } from '../../app.component';
import { AppMainComponent } from '../../app.main.component';
import { AppMenuComponent } from '../menu/app.menu.component';
import { AvatarModule } from 'primeng/avatar';
@Component({
    standalone: true,
    selector: 'app-topbar',
    styles: [`:host ::ng-deep .p-avatar-text { color: #ffffff; }`],
    imports:[
        CommonModule,
        RouterLink,
        AvatarModule,
        AppMenuComponent
    ],
    template: `
        <div class="layout-topbar">
            <div class="layout-topbar-left">
                <a href="#" class="topbar-menu-button" (click)="appMain.onMenuButtonClick($event)" *ngIf="appMain.isOverlay() || appMain.isMobile()">
                    <i class="pi pi-bars"></i>
                </a>

                <a href="#" class="logo">
                    <img  [src]="'assets/layout/images/logo-'+ (app.colorScheme === 'light' ? 'dark' : 'light') + '.png'">
                </a>

                <a href="#">
                    <img  [src]="'assets/layout/images/appname-'+ (app.colorScheme === 'light' ? 'dark' : 'light') + '.png'" class="app-name"/>
                </a>
            </div>

             <app-menu></app-menu>

          <div class="layout-topbar-right" *ngIf="!appMain.isAccountFlow()">
                <ul class="layout-topbar-right-items">
                    <li #profile class="profile-item" [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === profile}">
                        <a href="#" (click)="appMain.onTopbarItemClick($event,profile)">
                            <p-avatar [label]="appMain.avatarLabel" shape="circle" severity="danger" [style]="{'background-color': '#873EFE'}"></p-avatar>
                        </a>

                        <ul class="fadeInDown">
                            <li class="layout-inline-menu-action-item">
                                <a [routerLink]="['/settings/profile']">
                                    <i class="pi pi-user pi-fw"></i>
                                    <span >Profiles</span>
                                </a>
                            </li>
                            <li class="layout-inline-menu-action-item">
                                <a [routerLink]="['/settings/manage/projects']">
                                    <i class="fi fi-tr-diagram-project"></i>
                                    <span >Projects</span>
                                </a>
                            </li>
                            <li class="layout-inline-menu-action-item">
                                <a [routerLink]="['/billing/subscription']">
                                    <i class="fi fi-tr-money-check"></i>
                                    <span >Change Plan</span>
                                </a>
                            </li>
                            <li class="layout-inline-menu-action-item">
                                <a href="#" (click)="appMain.onLogoutClicked()">
                                    <i class="pi pi-power-off pi-fw"></i>
                                    <span>Logout</span>
                                </a>
                            </li>
                        </ul>
                    </li>

                </ul>
            </div>
        </div>

                            <!-- <li>
                        <a href="#">
                            <i class="topbar-icon pi pi-fw pi-bell"></i>
                            <span class="topbar-badge">2</span>
                            <span class="topbar-item-name">Notifications</span>
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i class="topbar-icon pi pi-fw pi-comment"></i>
                            <span class="topbar-badge">5</span>
                            <span class="topbar-item-name">Messages</span>
                        </a>
                    </li> -->
    `
})
export class AppTopbarComponent {

    constructor(public app: AppComponent, public appMain: AppMainComponent) { }

}
